/**
 * @lodex-pro/web-billing/auth/SignInPage — sign-in page.
 *
 * The shared sign-in screen (web-shared SignInScreen, 2026-10-21: "All sign in screens should be
 * the same"): email + password, MFA, "Forgot your password?" and the forced new password. Until
 * then this page rendered the flow without the card, so it looked unlike the other apps.
 *
 * Navigation is a full-page `window.location.assign`; the props let tests stub it.
 *
 * Branding: `Paelode Systems Billing` (legal brand on invoicing surfaces per CLAUDE.md).
 */

import { SignInScreen } from '@lodex-pro/web-shared';
import type { FC } from 'react';

export interface SignInPageProps {
  readonly onSignedIn?: () => void;
  readonly onTotpSetupRequired?: () => void;
}

export const SignInPage: FC<SignInPageProps> = ({ onSignedIn, onTotpSetupRequired }) => (
  <SignInScreen
    appName="Paelode Systems Billing"
    onSignedIn={() => {
      if (onSignedIn !== undefined) {
        onSignedIn();
        return;
      }
      window.location.assign('/');
    }}
    onTotpSetupRequired={() => {
      if (onTotpSetupRequired !== undefined) {
        onTotpSetupRequired();
        return;
      }
      window.location.assign('/auth/totp-setup');
    }}
  />
);
